module.exports = __webpack_public_path__ + "static/media/home_header.e758e38a.jpg";